<div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
  <div class="pb-5  mb-4 relative">
     <ol class="carousel-indicators  ">
         <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active bg-secondary"></li>
         <li data-target="#carouselExampleIndicators" data-slide-to="1" class="bg-secondary"></li>
         <li data-target="#carouselExampleIndicators" data-slide-to="2" class="bg-secondary"></li>
         <li data-target="#carouselExampleIndicators" data-slide-to="3" class="bg-secondary"></li>
       </ol>
       <div class="carousel-inner">
         <div class="carousel-item active text-center">
           <h2>Enter your basic details.</h2>
           <img class="d-block w-100" src="https://cdn.virtueanalytics.com/cache/01-basic-details.png" alt="First slide">
          
         </div>
         <div class="carousel-item text-center">
           <h2>Enter your academic details.</h2>
           <img class="d-block w-100" src="https://cdn.virtueanalytics.com/cache/02-academic-details.png" alt="Second slide">
           
         </div>
         <div class="carousel-item text-center">
           <h2>Choose your preferred colleges</h2>
           <img class="d-block w-100" src="https://cdn.virtueanalytics.com/cache/03-college-of-interes.png" alt="Third slide">
         </div>
         <div class="carousel-item text-center">
           <h2>Your college comparison (Click on college name for more information)</h2>
           <img class="d-block w-100" src="https://cdn.virtueanalytics.com/cache/04-college-comparison.png" alt="Third slide">
           
         </div>
   
       </div>
  </div>
 <div class="text-center">
   
   <button type="submit" class="btn btn-primary page-btn m-0" 
   (click)="onClose()">Skip</button>
 </div>
<a class="carousel-control-prev st-btn" href="#carouselExampleIndicators" role="button" data-slide="prev">
   <span class="carousel-control-prev-icon" aria-hidden="true"></span>
   <span class="sr-only">Previous</span>
 </a>
 <a class="carousel-control-next st-btn" href="#carouselExampleIndicators" role="button" data-slide="next">
   <span class="carousel-control-next-icon" aria-hidden="true"></span>
   <span class="sr-only">Next</span>
 </a> 
</div>

